import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';


import { fetchTransitionList } from './FetchTransactions';
import LoadingElement from '../components/features/LoadingElement';
import { checkMoney } from '../utils/configData';

export const Client = ({ clientData, client_id }) => {
    const { t } = useTranslation();
    const [sort, setSort] = useState({ orderBy: "id", order: "up", offset: 0 });
    const [transactions, setTransactions] = useState([]);
    const initials = useState(
        clientData.fname[0] + clientData.lname[0] // set initials
    );
    const [page, setPage] = useState(0);
    const listTransations = async (id, sort) => {
        fetchTransitionList(id, sort).then((data) => {
            console.log(data, "transactions");
            if (data) {
                const a = Number(data.count) / 8;
                setTransactions(data.transactions);
                if (a > 1) {
                    setPage(Math.ceil(a));
                }
            }
        });
    };
    useEffect(() => {
        listTransations(client_id, sort);
    }, [client_id, sort]);

    const userAvatar = clientData.avatar ? ( // if avatar exists, display it, else display initials
        <img src={clientData.avatar} alt="avatar" /> // (Workpiece for extension, currently there is no functionality for uploading a user photo)
    ) : (
        <p>{initials}</p>
    );

    const verifIcon = clientData.verif ? (clientData.verif === 1 ? <div className='kyc-verif'>KYC</div> : <div className='aml-verif'>AML</div>) : (<div className='none-verif'>-</div>);

    function copyToClipboard(input, event) {
        // Перевіряємо, чи підтримує браузер Clipboard API
        if (!navigator.clipboard) {
            console.error('Clipboard API не підтримується у вашому браузері.');
            // Змінюємо клас елемента на помилковий
            if (event && event.target) {
                event.target.className = 'disabled';
            }
            return;
        }

        // Перетворюємо вхідні дані на рядок, якщо вони не є рядком
        const textToCopy = typeof input === 'string' ? input : input.toString();

        // Використовуємо API для запису в буфер обміну
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                console.log('Текст успішно скопійований в буфер обміну.');
                // Змінюємо клас елемента на успішний
                if (event && event.target) {
                    event.target.className = 'ri-check-line';
                    setTimeout(() => {
                        event.target.className = 'ri-clipboard-line';
                    }, 1500);
                }
            })
            .catch(err => {
                console.error('Сталася помилка при копіюванні в буфер обміну:', err);
                // Змінюємо клас елемента на помилковий
                if (event && event.target) {
                    event.target.className = 'ri-close-line';
                    setTimeout(() => {
                        event.target.className = 'ri-clipboard-line';
                    }, 1500);
                }
            });
    }

    const sortTransactions = (by) => {
        if (by === sort.orderBy) {
            setSort((prev) => ({
                ...prev,
                order: sort.order === "up" ? "down" : "up",
                offset: 0,
            }));
        }
        if (by !== sort.orderBy) {
            setSort({ orderBy: by, order: "up", offset: 0 });
        }
    };

    const renderPageButtons = () => {
        const buttons = [];


        buttons.push(
            <button
                key={0}
                className={`setOffset ${sort.offset === 0 ? "active" : ""}`}
                onClick={() => setSort((prev) => ({ ...prev, offset: 0 }))}
            >
                <p style={{ width: "20px" }}>1</p>
            </button>
        );


        let start, end;

        if (sort.offset <= 2) {
            start = 1;
            end = Math.min(page - 2, 3);
        } else if (sort.offset >= page - 3) {
            start = Math.max(page - 4, 1);
            end = page - 2;
        } else {
            start = sort.offset - 1;
            end = sort.offset + 1;
        }


        if (start > 1) {
            buttons.push(<span key="start-ellipsis">...</span>);
        }

        for (let i = start; i <= end; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`setOffset ${sort.offset === i ? "active" : ""}`}
                    onClick={() => setSort((prev) => ({ ...prev, offset: i }))}
                >
                    <p style={{ width: "20px" }}>{i + 1}</p>
                </button>
            );
        }


        if (end < page - 2) {
            buttons.push(<span key="end-ellipsis">...</span>);
        }


        buttons.push(
            <button
                key={page - 1}
                className={`setOffset ${sort.offset === page - 1 ? "active" : ""}`}
                onClick={() => setSort((prev) => ({ ...prev, offset: page - 1 }))}
            >
                <p style={{ width: "20px" }}>{page}</p>
            </button>
        );

        return buttons;
    };

    return (
        <div className="client-page">
            <h1>{t("User info")}</h1>
            <div className="client-page__container">
                <div className="client-page__img">{userAvatar}</div>
                <p>{clientData.fname}{clientData.mname ? ` ${clientData.mname} ` : " "}{clientData.lname}</p>
            </div>

            <div className='client-page__item'>
                <p>{t("Verification")}</p> {verifIcon}
            </div>



            <div className='client-page__item'>
                <p>{t("Email")}</p> <div className='client-page__item-right'>{clientData.email} <i onClick={(event) => copyToClipboard(clientData.email, event)} className="ri-clipboard-line"></i></div>
            </div>

            <div className='client-page__item'>
                <p>{t("Phone")}</p> <div className='client-page__item-right'>{clientData.phone} <i onClick={(event) => copyToClipboard(clientData.phone, event)} className="ri-clipboard-line"></i></div>
            </div>

            <div className='client-page__item'>
                <p>SUMSUB ID</p> <div className='client-page__item-right'>{clientData.sumsub} <i onClick={(event) => copyToClipboard(clientData.sumsub, event)} className="ri-clipboard-line"></i></div>
            </div>

            <h1 className='mt-24'>{t("Transactions")}</h1>
            <div className="transactions-list__table client">
                <div className="transactions-list__table-wrapper">
                    <h2
                        className="start click"
                        onClick={() => sortTransactions("id")}
                    >
                        {t("ID")}
                    </h2>
                    {transactions.map((transaction) => {
                        return (
                            <div
                                className="transactions-list__table-item start"
                                key={transaction.id}
                            >
                                #{transaction.id.slice(0, 4)}...
                            </div>
                        );
                    })}
                </div>
                <div className="transactions-list__table-wrapper">
                    <h2
                        onClick={() => sortTransactions("status")}
                        className="click">
                        {t("Status")}
                    </h2>
                    {transactions.map((transaction) => {
                        let textStatus = <LoadingElement mini={true} />;
                        if (transaction.status === 0) {
                            textStatus = "Matching";
                        } else if (transaction.status === 1) {
                            textStatus = "Pending";
                        } else if (transaction.status === 2) {
                            textStatus = "Reviewing";
                        } else if (transaction.status === 3) {
                            textStatus = "Fulfilled";
                        } else if (transaction.status === 4) {
                            textStatus = "Cancelled";
                        }
                        return (
                            <div
                                className="transactions-list__table-item"
                                key={transaction.id}
                            >
                                <p className={`status ${textStatus}`}>{textStatus}</p>
                            </div>
                        );
                    })}
                </div>


                <div className="transactions-list__table-wrapper">
                    <h2 className="click" onClick={() => sortTransactions("opened")}>
                        {t("Date")}
                    </h2>
                    {transactions.map((transaction) => {

                        function formatDate(dateString) {
                            if (dateString !== null) {
                                const cleanedDateString = dateString.split('.')[0];
                                const date = new Date(cleanedDateString);
                                const hours = date.getHours().toString().padStart(2, '0');
                                const minutes = date.getMinutes().toString().padStart(2, '0');
                                const day = date.getDate().toString().padStart(2, '0');
                                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                                const year = date.getFullYear();

                                return `${hours}:${minutes}, ${day}.${month}.${year}`;
                            } else {
                                return "–"
                            }
                        }

                        return (
                            <div
                                className="transactions-list__table-item wallet"
                                key={transaction.id}
                            >
                                <div>
                                    {transaction.opened ? <h3 style={{ textWrap: "nowrap" }}>
                                        <span>open:</span>
                                        {formatDate(transaction.opened)}
                                    </h3> : null}
                                    {transaction.closed ? <h3 style={{ textWrap: "nowrap" }}>
                                        <span>closed:</span>
                                        {formatDate(transaction.closed)}
                                    </h3> : null}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="transactions-list__table-wrapper">
                    <h2
                        onClick={() => sortTransactions("sell_amount")}
                        className="click">
                        {t("Give")}
                    </h2>

                    {transactions.map((transaction) => {
                        const currencyImg = checkMoney(transaction.sell_currency).img;
                        return (
                            <div
                                className="transactions-list__table-item"
                                key={transaction.id}
                            >
                                <img src={currencyImg} alt="" />

                                <p>{transaction.sell_amount}</p>
                            </div>
                        );
                    })}
                </div>
                <div className="transactions-list__table-wrapper">
                    <h2
                        onClick={() => sortTransactions("buy_amount")}
                        className="click">
                        {t("Receive")}
                    </h2>

                    {transactions.map((transaction) => {
                        const currencyImg = checkMoney(transaction.buy_currency).img;
                        return (
                            <div
                                className="transactions-list__table-item end"
                                key={transaction.id}
                            >
                                <img src={currencyImg} alt="" />
                                <p>{(Number(transaction.buy_amount) - Number(transaction.fee)).toFixed(2)}</p>
                            </div>
                        );
                    })}
                </div>
                {page ? (
                    <div className="footer-list">
                        <div className="footer-list-flex">
                            {renderPageButtons()}
                            <button
                                className="setOffset"
                                style={{ paddingLeft: "12px" }}
                                onClick={() =>
                                    setSort((prev) => ({
                                        ...prev,
                                        offset: Math.min(prev.offset + 1, page - 1),
                                    }))
                                }
                            >
                                Next <i className="ri-arrow-drop-right-line"></i>
                            </button>
                        </div>

                    </div>
                ) : null}
            </div>


        </div>
    )
}
